export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/bg.40047cf1.svg","height":464,"width":1676,"blurWidth":0,"blurHeight":0};